// http://localhost:3000/del/OTc3Yzk3YjgtZmIxMi00YzYwLTk2YTItN2RmYWEyZTI4MWI2
import React, { PureComponent } from 'react';
import {Helmet} from 'react-helmet';
import { ImageresizeApi } from 'modules';

import styles from './styles';

class Delete extends PureComponent {
  state = {
    status: 'deleting'
  };

  componentDidMount() {
    const { match } = this.props;
    const imageId = atob(match.params.imageId);
    let $this = this;

    ImageresizeApi.requestImageMetadata(imageId, this.state.version)
      .then((response) => {
          ImageresizeApi.deleteImage(imageId)
          .then(() => {
            $this.setState({
              status: 'deleted'
            });
          })
          .catch(() => {
            $this.setState({
              status: 'error'
            });
          })
      })
      .catch(() => this.setState({
        status: 'error'
      }));
  }

  render() {
    let msg = '';
    switch(this.state.status) {
      case 'deleted':
        msg = 'Image Deleted Successfully.';
        break;
      case 'error':
        msg = 'No image was found on our server for the given link.';
        break;
      default:
        msg = 'Deleting Image...';
    }
    return (
      <div className='container'>
        <Helmet>
          <title>Delete Image | ImageResize.org</title>
        </Helmet>
        <div className={`${styles.masthead} container`}>
          <h2>
            {msg}
          </h2>
        </div>
      </div>
    )
  };
}

export default Delete;



// WEBPACK FOOTER //
// ./src/containers/Delete/index.jsx